import { SaleFactorType } from 'src/app/enum/sale-factor-type';

export class GetActivePrescriptionViewModel {
  constructor(salefactorType: SaleFactorType) {
    this.saleFactorType = salefactorType;
  }

  public nationalCode?: string;
  public trackingCode?: string;

  public token?: string;
  public citizenToken?: string;

  public saleFactorType: SaleFactorType;
}
